var render = function render(){var _vm=this,_c=_vm._self._c;return _c(!_vm.mainPageUrl ? 'nuxt-link' : 'a',{tag:"component",attrs:{"to":{name: 'home'},"href":_vm.mainPageUrl}},[_c('img',{staticClass:"d-block logo",style:(_vm.logoStyle),attrs:{"src":_vm._f("srcHost")(_vm.logo),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }